export default __webpack_public_path__ + "static/Fig 2 - Site Location Plan-7837011d0c2a61e550a370e65aaf8927.pdf";